import { router } from '@inertiajs/react';
import { formatInTimezone, getMotelToday } from './utils/timezone';

declare global {
    interface Window {
        Time: {
            format: (
                date: string | Date | number,
                formatStr?: string,
                tz?: string,
            ) => string;
            today: (tz?: string) => Date;
            now: (formatStr?: string, tz?: string) => string;
            timezone: () => string;
        };
    }
}

window.Time = {
    timezone: () => {
        try {
            // Priority 1: Inertia router (runtime props)
            const routerData = router as unknown as {
                page?: { props?: { timezone?: string } };
            };
            if (routerData.page?.props?.timezone) {
                return routerData.page.props.timezone;
            }

            // Priority 2: Initial page load data from DOM
            const el = document.getElementById('app');
            if (el?.dataset.page) {
                const page = JSON.parse(el.dataset.page);
                return page?.props?.timezone || 'UTC';
            }
        } catch {
            // Silent fallback
        }
        return 'UTC';
    },
    format: (date, formatStr, tz) =>
        formatInTimezone(date, tz || window.Time.timezone(), formatStr),
    today: (tz) => getMotelToday(tz || window.Time.timezone()),
    now: (formatStr, tz) =>
        formatInTimezone(new Date(), tz || window.Time.timezone(), formatStr),
};
